import React, { useCallback, useContext } from 'react'

import { UploadButton as UploadButtonComponent, UploadButtonError } from '@grammarly/website-components'
import { gnarSpec } from '../../../../../lib/tracking/gnar'
import { useBrowserService, useApiService } from '../../../../../lib/hooks'
import { PageContext } from '../../../../../contexts/page-context'

import { TextCheckStatus } from '../types'

interface UploadButtonProps {
  setStatus: (status: TextCheckStatus) => void
  setText: (text: string) => void
  className?: string
}

export const UploadButton: React.FC<UploadButtonProps> = ({ setStatus, setText, className }) => {
  const browserService = useBrowserService()
  const { pageId, slug } = useContext(PageContext)
  const { dox } = useApiService()

  const onClickHandler = useCallback(() => {
    gnarSpec.uploadFileForTextCheckButtonClick(pageId, slug)
  }, [pageId, slug])

  const onFileUploadStart = () => {
    setStatus('LOADING_FILE')
  }

  const onFileUploadFinish = (text: string) => {
    setText(text)
    setStatus('ACTIVE')
  }

  const onFileUploadError = (error: UploadButtonError) => {
    setStatus(error)
  }

  if (browserService.isMobileOrTablet) {
    return null
  }

  return (
    <UploadButtonComponent
      doxClient={dox}
      text="Upload a file"
      onClick={onClickHandler}
      onFileChangeStart={onFileUploadStart}
      onFileChangeFinish={onFileUploadFinish}
      onError={onFileUploadError}
      className={className}
    />
  )
}
